import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homecare',
  templateUrl: './homecare.component.html',
  styleUrls: ['./homecare.component.scss']
})
export class HomecareComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
